const l = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill="currentColor" fill-rule="evenodd" d="M0 0h16v16H0zm1.021 1.021V14.98H14.98V1.02zM7.278 8 1.086 1.808l.722-.722L8 7.278l6.192-6.192.722.722L8.722 8l6.192 6.192-.722.722L8 8.722l-6.192 6.192-.722-.722z" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>';
export {
  l as default
};
